var render = function render(){var _vm=this,_c=_vm._self._c;return _c('document-link',{staticClass:"pretty-book-link has-hover-background",attrs:{"document":_vm.book}},[_c('pretty-book',{attrs:{"book":_vm.book}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }